import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <h1 className="footer__title">Mohammed</h1>
        <ul className="footer__list">
          <li>
            <a href="#about" className="footer__link">
              About
            </a>
          </li>
          <li>
            <a href="#portfolio" className="footer__link">
              Projects
            </a>
          </li>
          <li>
            <a href="#services" className="footer__link">
              Services
            </a>
          </li>
        </ul>
        <div className="footer__social">
          <a
            href="https://www.linkedin.com/in/mohammed-hamzza/"
            rel="noreferrer"
            className="footer__social-icon"
            target="_blank"
          >
            <i style={{ color: "blue" }} className="bx bxl-linkedin"></i>
          </a>
          <a
            href="https://gitlab.com/Mohammed12"
            rel="noreferrer"
            className="footer__social-icon"
            target="_blank"
          >
            <i style={{ color: "orange" }} className="bx bxl-gitlab"></i>
          </a>
          <a
            href="https://github.com/mohammedhamza2017"
            rel="noreferrer"
            className="footer__social-icon"
            target="_blank"
          >
            <i className="bx bxl-github"></i>
          </a>
        </div>
        <span className="footer__copy">
          {" "}
          2023 &#169; Mohammed Hameza. All rights reserved.{" "}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
